import React from 'react';
import styles from './Regions.module.css';

const Regions = () => {
  const regions = [
    { name: 'Москва', domain: 'moscow.regioncheck.ru', code: 'MOW' },
    { name: 'Санкт-Петербург', domain: 'spb.regioncheck.ru', code: 'SPB' },
    { name: 'Челябинск', domain: 'chelyabinsk.regioncheck.ru', code: 'CHE' },
    { name: 'Уфа', domain: 'ufa.regioncheck.ru', code: 'UFA' },
    // { name: 'Екатеринбург', domain: 'ekaterinburg.regioncheck.ru', code: 'EKB' },
    // { name: 'Казань', domain: 'kazan.regioncheck.ru', code: 'KZN' },
    // { name: 'Новосибирск', domain: 'novosibirsk.regioncheck.ru', code: 'NSK' },
    // { name: 'Краснодар', domain: 'krasnodar.regioncheck.ru', code: 'KRR' },
    // { name: 'Ростов-на-Дону', domain: 'rostov.regioncheck.ru', code: 'RND' },
    // { name: 'Нижний Новгород', domain: 'nn.regioncheck.ru', code: 'GOJ' },
    // { name: 'Самара', domain: 'samara.regioncheck.ru', code: 'KUF' },
    // { name: 'Владивосток', domain: 'vladivostok.regioncheck.ru', code: 'VVO' },
  ];

  const currentDomain = window.location.hostname;

  return (
    <section id="regions" className={`section ${styles.regions}`}>
      <div className="container">
        <div className={styles.regionsHeader}>
          <h2 className={styles.sectionTitle}>Наши филиалы по городам</h2>
          <p className={styles.sectionSubtitle}>
            Выберите ваш город для заказа гостиничных чеков с QR-кодом
          </p>
        </div>
        
        <div className={styles.regionsGrid}>
          {regions.map((region) => (
            <a
              key={region.code}
              href={`https://${region.domain}`}
              className={`${styles.regionCard} ${
                currentDomain === region.domain ? styles.currentRegion : ''
              }`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className={styles.regionIcon}>
                <i className="fa fa-building"></i>
              </div>
              <h3 className={styles.regionName}>{region.name}</h3>
              <div className={styles.regionDomain}>{region.domain}</div>
              <div className={styles.regionLink}>
                Перейти на сайт <i className="fa fa-external-link"></i>
              </div>
            </a>
          ))}
        </div>
        
        <div className={styles.regionsInfo}>
          <p className={styles.infoText}>
            Каждый региональный сайт предоставляет услуги в своём городе.<br />
            Все чеки оформляются от действующих гостиниц региона.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Regions;